{
  "accordeon": [
    {
      "title": "Pomiar",
      "text": "Skorzystaj z narzędzia “Wellbeing score” i poznaj poziom dobrostanu w swoim zespole."
    },
    {
      "title": "Strategia",
      "text": "Wspólnie stworzymy plan wdrożenia rozwiązań wellbeingowych, uwzględniający specyficzne potrzeby Twojej organizacji."
    },
    {
      "title": "Wsparcie",
      "text": "Korzystaj z nowoczesnych narzędzi i wiedzy ekspertów, rozwijając i wspierając zespół."
    },
    {
      "title": "Efekty",
      "text": "Zapobiegaj negatywnym skutkom wypalenia i obserwuj wzrost zaangażowania pracowników."
    }
  ]
}